module.exports = "https://static.wanderu.com/ui-react/_next/static/media/mashable-x2.29e1f91a.png";